import { PROF_ROLE } from '../helpers/user/authorization';
import { Icon } from '../components/atoms/Icons';
import emojis from '../theme/emoji';
import { Emoji } from '../components/molecules/TopBar';

export interface Page {
  path: AppPath;
  linkName?: string;
  icon?: Icon;
  type?: string;
  hide?: boolean;
  external?: boolean;
  isOnBottomMenu?: boolean;
  emoji?: Emoji;
  displayName?: string;
}

export type LinkParams = 'id' | 'shopId' | 'idProduit' | 'classeId' | 'type';

const PARAMS = 'params';
const LOGGED = 'logged';
const PROF = PROF_ROLE;

const pages = {
  HOME_PAGE: {
    path: '/',
    linkName: 'Dashboard',
    icon: 'Home',
    type: LOGGED,
    isOnBottomMenu: true,
    emoji: emojis['WavingHand']
  },
  SIGN_UP: {
    path: '/inscription'
  },
  SIGN_IN: {
    path: '/'
    //Doit rester en dessous de HOME_PAGE car ils ont la même route CF : getRouteNameByCurrentLocation()
  },
  SUCCESS: {
    path: '/success'
  },
  REINITIALISER: {
    path: '/reinitialiser'
  },
  CONFIRM_REINIT: {
    path: '/reinitialiser/:id'
  },
  LOGOUT: {
    path: '/logout'
  },
  COMMANDE_SINGLE_PAGE: {
    path: '/commande/:id',
    displayName: 'Récapitulatif de commande',
    emoji: emojis['FaxMachine']
  },
  QUIZ_SINGLE_PAGE: {
    path: '/quiz/:id',
    displayName: 'Activité Quiz',
    emoji: emojis['FlagInHole']
  },
  PRODUCT_SINGLE_PAGE: {
    path: '/produits/:idProduit'
  },
  COMMANDE_PAGE: {
    path: '/commande',
    displayName: 'Commande',
    emoji: emojis['FaxMachine']
  },
  PRODUCTS_PAGE: {
    path: '/produits',
    linkName: 'Reporting',
    icon: 'Pocket',
    type: LOGGED,
    isOnBottomMenu: true,
    emoji: emojis['Label'],
    displayName: 'Liste des produits'
  },
  MES_COMMANDES_PAGE: {
    path: '/mes-commandes',
    linkName: 'Mes ventes',
    icon: 'Money',
    type: LOGGED,
    displayName: 'Liste des commandes',
    emoji: emojis['PageWithCurl']
  },
  DOCUMENTS_PAGE: {
    path: '/documents',
    linkName: 'Ressources',
    icon: 'Graduate',
    type: LOGGED,
    isOnBottomMenu: true,
    displayName: 'Ressources',
    emoji: emojis['Books']
  },
  RESSOURCES_PAGE: {
    path: '/ressources',
    displayName: 'Ressources du challenge',
    emoji: emojis['Books']
  },
  RESSOURCES_TYPE_PAGE: {
    path: '/ressources/categorie/:id',
    displayName: 'Ressources du challenge',
    emoji: emojis['Books']
  },
  PEDAGOGIES_PAGE: {
    path: '/pedagogies',
    displayName: 'Ressources pédagogiques',
    emoji: emojis['OpenFileFolder']
  },
  PEDAGOGIES_TYPE_PAGE: {
    path: '/pedagogies/categorie/:id',
    displayName: 'Ressources pédagogiques',
    emoji: emojis['OpenFileFolder']
  },
  FORMATIONS_PAGE: {
    path: '/formations',
    displayName: 'Pour se former',
    emoji: emojis['GradutationCap']
  },
  FORMATIONS_TYPE_PAGE: {
    path: '/formations/categorie/:id',
    displayName: 'Pour se former',
    emoji: emojis['GradutationCap']
  },
  QUIZ_PAGE: {
    path: '/quizzes',
    linkName: 'Quiz à faire',
    icon: 'Puzzle',
    type: LOGGED,
    isOnBottomMenu: true,
    displayName: 'Liste des quiz',
    emoji: emojis['Memo']
  },
  NOTE_PAGE: {
    path: '/notes',
    linkName: 'Mes notes',
    icon: 'Ranking',
    type: LOGGED,
    displayName: 'Mes notes',
    emoji: emojis['BarChart']
  },
  PANIER_PAGE: {
    path: '/panier',
    linkName: 'Panier',
    icon: 'ShoppingCart',
    hide: true,
    isOnBottomMenu: true,
    displayName: 'Panier',
    emoji: emojis['ShoppingCart']
  },
  MY_ACCOUNT: {
    path: '/moncompte',
    linkName: 'Mon compte',
    icon: 'Profile',
    type: PARAMS,
    displayName: 'Mon compte',
    emoji: emojis['SmilingFaceWithSunglasses']
  },
  FAQ_PAGE: {
    path: '/faq',
    linkName: 'La Faq',
    icon: 'Interogation',
    type: PARAMS,
    displayName: 'Foire aux questions',
    emoji: emojis['NerdFace']
  },
  NOT_FOUND: {
    path: '/',
    linkName: 'Dashboard',
    icon: 'Home'
  },
  CLASSE_SETTINGS_PAGE: {
    path: '/ma-classe',
    linkName: 'Ma Classe',
    icon: 'UserGroup',
    type: LOGGED,
    displayName: 'Ma classe',
    emoji: emojis['GradutationCap']
  },
  CREATE_CLASSE_PAGE: {
    path: '/create-classe',
    type: PROF_ROLE,
    hide: true
  },
  RECAP_QUIZ_CLASSE_PAGE: {
    path: '/ma-classe/:classeId/recap-quiz/:id',
    type: PROF_ROLE,
    displayName: 'Récapitulatif quiz',
    emoji: emojis['BarChart'],
    hide: true
  },
  ELEVE_ACCOUNT_PAGE: {
    path: '/edit-eleve/:id',
    hide: true,
    type: PROF_ROLE,
    displayName: 'Ma classe',
    emoji: emojis['Key']
  },
  COMMANDE_ELEVE_DETAILS: {
    path: '/liste-commande-eleve/:id',
    hide: true,
    type: PROF_ROLE
  },
  UPDATE_COMMANDE_PAGE: {
    path: '/modifier-commande/:id',
    hide: true,
    type: PROF_ROLE,
    displayName: 'Édition de commande',
    emoji: emojis['FaxMachine']
  },
  ESPACE_PROF: {
    path: '/espace-prof',
    hide: true,
    type: PROF_ROLE
  },
  NGO: {
    path: '/ong',
    hide: true,
    displayName: 'Contribution ONG',
    emoji: emojis['Globe']
  },
  NGO_CHOICE_PAGE: {
    path: '/ong/presentation/:type',
    hide: true,
    displayName: 'Contribution ONG',
    emoji: emojis['Globe']
  },
  PEDAGOGICAL_CHALLENGES: {
    path: '/defis',
    hide: true,
    type: LOGGED
  },
  PEDAGOGICAL_CHALLENGE_SINGLE: {
    path: '/defis/:id',
    hide: true,
    type: LOGGED
  },
  PUBLIC_SHOP_HOME: {
    path: '/e-boutique/:shopId/:classeId'
  },
  PUBLIC_SHOP__SINGLE_PRODUCT: {
    path: '/e-boutique/:shopId/:classeId/produits/:idProduit'
  },
  PUBLIC_SHOP_PANIER: {
    path: '/e-boutique/:shopId/:classeId/panier'
  },
  PUBLIC_SHOP_COMMANDE: {
    path: '/e-boutique/:shopId/:classeId/commande'
  },
  PUBLIC_SHOP_RECAP_COMMANDE: {
    path: '/e-boutique/:shopId/:classeId/recapCommande'
  },
  PUBLIC_SHOP_INFO: {
    path: '/e-boutique/:shopId/:classeId/info'
  }
} as const;

type PageKeys = keyof typeof pages;
type PageDef = { [key in PageKeys]: Page };

export type AppPath = ValueOf<typeof pages>['path'];
export type RouterLinkParams = Partial<
  {
    [key in LinkParams]: string | number;
  }
>;

export default pages as PageDef;

export const loggedUserPages: Page[] = Object.keys(pages)
  .filter(key => pages[key].type === LOGGED)
  .map(obj => pages[obj]);

export const profPages: Page[] = Object.keys(pages)
  .filter(key => pages[key].type === PROF)
  .map(obj => pages[obj]);

export const settingPages: Page[] = Object.keys(pages)
  .filter(key => pages[key].type === PARAMS)
  .map(obj => pages[obj]);

export const bottomMenuPages: Page[] = Object.keys(pages)
  .filter(key => pages[key].isOnBottomMenu === true)
  .map(obj => pages[obj]);
